$(function () {
    $('.main-menu-button').click(function (e) {
        if ($('.main-navigation-dropdown').hasClass('active')) {
            $('.main-navigation-dropdown').removeClass('active');
            $('body').removeClass('main-nav-open');
        } else {
            $('.main-navigation-dropdown').addClass('active');
            $('body').addClass('main-nav-open');
        }
        e.preventDefault();
    });
    $('.sub-section-dropper').click(function () {
        $(this).parent().toggleClass('open');
    });

    $(window).on('scroll', function () {
        var y_scroll_pos = window.pageYOffset;
        var scroll_pos_test = 60;

        if (y_scroll_pos > scroll_pos_test) {
            $(".desktop-header").addClass("scrolling");
        } else {
            $(".desktop-header").removeClass("scrolling");
        }
    });

    $('.open-add').click(function (e) {
        e.preventDefault();

        var dataVal = $(this).hasClass('active') ? 'more' : 'less';
        $(this).text( $(this).data(dataVal) );
        $(this).toggleClass('active');
        $(this).next().toggleClass('open');
    });

    var offset = 125;
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        var elementValue = $.attr(this, 'href');

        if (elementValue != '#') {
            $('html, body').animate({
                scrollTop: $(elementValue).offset().top - offset
            }, 500);
        }
    });

    var $menu = $('.mmenu').mmenu({
        'iconPanels': { 'add': true, 'visible': 1, 'blockPanel': true },
        'extensions': [
		    'position-right'
        ],
        'navbar': {
            'title': ''
        }
    }, {
        // configuration
        classNames: {
            fixedElements: {
                fixed: "Fixed",
                sticky: "Sticky"
            }
        }
    });

    var API = $menu.data("mmenu");
    API.bind("close:start", function () {
        $(".mobile-menu-button").removeClass("open");

        $(".mobile-menu-button").data("opened", "false");
    });

    // MMenu button
    $(".mobile-menu-button").click(function () {
        if ($(this).data("opened") == "true") {
            API.close();
            $(this).data("opened", "false");
            $(this).removeClass("open");
        } else {
            API.open();
            $(this).data("opened", "true");
            $(this).addClass("open");
        }
    });

    $('#lang-select').change(function () {
        window.location = $(this).val();
    });

    ReplaceSVGs();
});

function ReplaceSVGs() {

    jQuery('img[src*=".svg"].inline-svg').each(function () {
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src') || $img[0].getAttribute('src');;

        var randID = ReplaceSVGsMakeId(10);

        jQuery.get(imgURL, function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            $svg = $svg.attr('class', 'svg-icon-' + randID);

            var $style = $svg.find('style');

            // Get all the classes
            var allClasses = [];
            var allSVGElements = $svg.find('*');

            for (var i = 0; i < allSVGElements.length; i++) {
                var classes = allSVGElements[i].classList.toString().split(/\s+/);
                for (var j = 0; j < classes.length; j++) {
                    var cls = classes[j];
                    if (cls && allClasses.indexOf(cls) === -1) {
                        allClasses.push(cls);

                        $style.html($style.html().split('.' + cls).join('.svg-icon-' + randID + ' .' + cls));
                    }
                }
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');

    });
}

function ReplaceSVGsMakeId(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}